import { createReducer, on } from '@ngrx/store';
import { ICustomer } from '../../models/customer.models';
import * as CustomersActions from '../actions/customers.actions';

export const customersFeatureKey = 'customers';

export interface CustomersState {
    customers: ICustomer[];
    selectedCustomer: ICustomer | null;
    loaded: boolean;
    loading: boolean;
    error?: string | null;
}

export const initialState: CustomersState = {
    customers: [],
    selectedCustomer: null,
    loaded: false,
    loading: false,
    error: null,
};

export const reducer = createReducer(
    initialState,
    on(CustomersActions.loadCustomers, state => ({ ...state, loading: true, error: null })),
    on(CustomersActions.loadCustomersSuccess, (state, { customers }) => ({ ...state, loading: false, loaded: true, customers })),
    on(CustomersActions.loadCustomersFailure, (state, { error }) => ({ ...state, loading: false, error })),

    on(CustomersActions.setSelectedCustomer, (state, { customer }) => ({ ...state, selectedCustomer: customer })),

    on(CustomersActions.createCustomerSuccess, (state, { customer }) => ({
        ...state,
        customers: state.customers ? [...state.customers, customer] : [customer],
    })),
    on(CustomersActions.updateCustomerSuccess, (state, { customer }) => ({
        ...state,
        customers: state.customers ? state.customers.map(c => (c.id === customer.id ? customer : c)) : [customer],
    })),
    on(CustomersActions.deleteCustomerSuccess, (state, { id }) => ({
        ...state,
        customers: state.customers ? state.customers.filter(c => c.id !== id) : [],
    }))
);

export const customersReducer = reducer;
